import React from "react";
import Resetpassword from "../Components/SignIN_SignUP/reset_password";
function ResetPassword() {
  return <Resetpassword />;
}

export default ResetPassword;
